import { useProfile } from "../hooks/useProfile";
import { Avatar, Spinner } from "flowbite-react";
import { Link } from "react-router-dom";
import { useAuth } from "react-oidc-context";

export const ProfilePage = () => {
  const { data: profile, isLoading, isError } = useProfile();
  const auth = useAuth();

  if (auth.isAuthenticated === false) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Please Login.</p>
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !profile) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">
          Error loading profile. Please try again later.
        </p>
      </div>
    );
  }

  const timestampToDate = (timestamp) => {
    if (!timestamp) return undefined;

    var date;
    if (typeof timestamp === typeof 1) {
      date = new Date(timestamp);
    } else {
      date = new Date(timestamp + "Z");
    }
    return date.toLocaleString();
  };

  return (
    <div className="container mx-auto p-8">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-2xl mx-auto">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-semibold text-gray-800">Profile</h1>
          <span className="bg-green-100 text-green-600 text-sm font-medium px-2 py-1 rounded-full">
            Active
          </span>
        </div>

        <div className="mt-6">
          <div className="flex items-center space-x-4">
            {/*         <div className="w-16 h-16 bg-gray-300 rounded-full overflow-hidden"> */}
              {/* Placeholder avatar */}
              <Avatar
                size="lg"
                alt="User Settings"
                placeholderInitials={auth.user.profile.name
                  .charAt(0)
                  .toUpperCase()}
                rounded
                {...(auth.user.profile.picture !== undefined
                  ? { img: `${auth.user.profile.picture}` }
                  : {})}
              />
            <div>
              <h2 className="text-xl font-semibold text-gray-700">
                {profile.name}
              </h2>
              <p className="text-gray-500">{profile.email}</p>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-medium text-gray-800">Details</h3>
            <div className="mt-4 space-y-4">
              <div className="flex justify-between">
                <span className="font-medium text-gray-600">Name:</span>
                <span className="text-gray-800">{profile.name}</span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-gray-600">Email:</span>
                <span className="text-gray-800">{profile.email}</span>
              </div>

              <div className="flex justify-between">
                <span className="font-medium text-gray-600">Joined:</span>
                <span className="text-gray-800">
                  {timestampToDate(profile.created_timestamp)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Transactions Section */}
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-xl mx-auto">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
          Transactions
        </h3>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              <tr>
                <th className="py-3 px-6 text-left">Date</th>
                <th className="py-3 px-6 text-left">Amount</th>
                <th className="py-3 px-6 text-left">Recipient</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light">
              {profile.transactions.map((transaction, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 hover:bg-gray-100"
                >
                  <td className="py-3 px-6 text-left">
                    {timestampToDate(transaction.txn_time)}
                  </td>
                  <td className="py-3 px-6 text-left">${transaction.amount}</td>
                  <td className="py-3 px-6 text-left">
                    <Link
                      to={`/${transaction.entity_type}/${transaction.nilo_id}`}
                    >
                      {transaction.name}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
